import React from "react";

import { Col, Row, Stack } from "react-bootstrap";

import classNames from "classnames";

import { ResaleFragment } from "@api/graphql";
import styles from "@pages/dashboard/DetailsDrawer.module.scss";
import { capitalizeFirstLetter } from "@util/index";

import { DetailCell } from "../resale_submission/DetailCell";

import { FieldFormatter } from "./FieldFormatter";

interface ArtworkDetailsProps {
  resale: ResaleFragment;
}

const ARTWORK_DETAILS_FORMATTERS: FieldFormatter<ResaleFragment>[] = [
  { title: "Artwork title", format: (resale: ResaleFragment) => resale.artwork_name || "-" },
  {
    title: "Medium",
    format: (resale: ResaleFragment) =>
      capitalizeFirstLetter(resale.medium?.toLocaleLowerCase().replace(/_/g, " ").replace(/ book/, "' book") || "-"),
  },
  { title: "Details or notes", format: (resale: ResaleFragment) => resale.description || "-" },
  { title: "Height", format: (resale: ResaleFragment) => (resale.artwork_height ? `${resale.artwork_height}cm` : "-") },
  { title: "Width", format: (resale: ResaleFragment) => (resale.artwork_width ? `${resale.artwork_width}cm` : "-") },
  { title: "Artist work ID", format: (resale: ResaleFragment) => resale.artist_work_id || "-" },
  { title: "Gallery work ID", format: (resale: ResaleFragment) => resale.gallery_work_id || "-" },
];

export const ArtworkDetailsDrawer = ({ resale }: ArtworkDetailsProps) => (
  <Stack gap={4} className="col-md-10">
    <Row>
      <span className={classNames(styles["stack-label"], "h5")}>Artwork details</span>
    </Row>
    <Row>
      {resale &&
        ARTWORK_DETAILS_FORMATTERS.map(({ title, format }) => (
          <Col md={6} className={styles["detail"]} key={title}>
            <DetailCell title={title} value={format(resale)} />
          </Col>
        ))}
    </Row>
  </Stack>
);
